import React, { useContext } from 'react';
import { GridRow, GridColumn, Heading, Text, Button, GridWrapper } from 'react-onei';

import TagService from '../../../services/TagService';
import UserContext from '../../../context/UserContext';
import { events } from '../../../conf/tags_ga.conf';

const ContactAccountOwner = () => {
    const { wording, serviceConf } = useContext(UserContext);
    const { redirectUrl } = serviceConf;
    const { WLOST_260, WLOST_261, WBUTTON_003 } = wording;

    function handleClick() {
        TagService.sendEvent(events.endNoContact);
        window.location.href = redirectUrl;
    };

    return (
        <GridWrapper>
            <GridRow>
                <GridColumn size={{ xs: 1, m: 8 / 12 }}>
                    <Heading as="h3" id="contact-owner-title" className="spacing-m">
                        {WLOST_260}
                    </Heading>
                    <Text id="contact-owner-message">
                        <div dangerouslySetInnerHTML={{__html: WLOST_261}}></div>
                    </Text>
                    <Button id="button-end" onClick={handleClick} className="spacing-s">
                        {WBUTTON_003}
                    </Button>
                </GridColumn>
            </GridRow>
        </GridWrapper>
    )
};

export default ContactAccountOwner;